export default "__VITE_ASSET__D1z9Cg8u__"